import { Badge } from '@/components/shadcn/badge'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/shadcn/card'
import { RestSchemas } from '@/contexts/QueryProvider'
import { statusBadge } from '@/pages/Applications/ApplicationsHome/ApllicationsGridItem'
import { ApplicationIcon } from '@/const'
import clsx from 'clsx'
import { Link } from 'react-router'

type MessagesDagsterApplication = RestSchemas['Messages.Dagster.DagsterApplication']
export function DagsterAppCard({ application }: { application: MessagesDagsterApplication }) {
  return (
    <Link
      className="block h-full overflow-visible rounded-xl bg-background transition-all"
      to={`/platform/dagster/${application.applicationId}`}
    >
      <Card className="h-full justify-between border-none duration-500 hover:bg-primary/5 hover:shadow-md">
        <CardHeader>
          <div className="flex items-center gap-x-3">
            <div
              className={clsx(
                'bg-offwhite flex size-14 shrink-0 items-center justify-center rounded-full text-foreground/50'
              )}
            >
              <ApplicationIcon className="size-6" />
            </div>
            <div className="flex w-full flex-col gap-y-1">
              <CardTitle className="text-lg font-medium leading-tight">{application.appName}</CardTitle>
              <Badge
                className={clsx(
                  'h-4 w-fit font-light',
                  statusBadge[application.status as keyof typeof statusBadge] ||
                    'border-muted bg-muted text-foreground/50'
                )}
                variant="secondary"
              >
                {application.status}
              </Badge>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <CardDescription className="line-clamp-2 text-xs font-light leading-tight">
            {application.dagsterUrl}
          </CardDescription>
        </CardContent>
        <CardFooter>
          <div className="flex w-full justify-end gap-x-1">
            <Badge
              className="bg-muted font-medium text-foreground hover:bg-muted hover:text-foreground"
              variant="secondary"
            >
              {application.appKey}
            </Badge>
          </div>
        </CardFooter>
      </Card>
    </Link>
  )
}
